// annual meeting 2025
import preAnualMeeting25Image1 from "../../assets/images/annual meeting march 2025/an25-1.jpg"
import preAnualMeeting25Image2 from "../../assets/images/annual meeting march 2025/an25-2.jpg"
import preAnualMeeting25Image3 from "../../assets/images/annual meeting march 2025/an25-3.jpg"
import preAnualMeeting25Image4 from "../../assets/images/annual meeting march 2025/an25-4.jpg"
import preAnualMeeting25Image6 from "../../assets/images/annual meeting march 2025/an25-8.jpg"
import preAnualMeeting25Image7 from "../../assets/images/annual meeting march 2025/an25-11.jpg"
import preAnualMeeting25Image8 from "../../assets/images/annual meeting march 2025/an25-14.jpg"
import preAnualMeeting25Image9 from "../../assets/images/annual meeting march 2025/an25-20.jpg"
import preAnualMeeting25Image10 from "../../assets/images/annual meeting march 2025/an25-21.jpg"
import preAnualMeeting25Image11 from "../../assets/images/annual meeting march 2025/an25-23.jpg"
import preAnualMeeting25Image12 from "../../assets/images/annual meeting march 2025/an25-27.jpg"
import preAnualMeeting25Image13 from "../../assets/images/annual meeting march 2025/an25-29.jpg"
import preAnualMeeting25Image44 from "../../assets/images/annual meeting march 2025/an25-44.jpg"


// annual meeting 2024
import preAnualMeeting24ImageOne from "../../assets/images/annual meeting march 24/Annual meeting march 24-1.jpeg"
import preAnualMeeting24Image2 from "../../assets/images/annual meeting march 24/Annual meeting march 24-2.jpeg"
import preAnualMeeting24Image3 from "../../assets/images/annual meeting march 24/Annual meeting march 24-3.jpeg"
import preAnualMeeting24Image4 from "../../assets/images/annual meeting march 24/Annual meeting march 24-5.jpeg"
import preAnualMeeting24Image5 from "../../assets/images/annual meeting march 24/Annual meeting march 24-7.jpeg"
import preAnualMeeting24Image6 from "../../assets/images/annual meeting march 24/Annual meeting march 24-8.jpeg"
// annual meeting 2023
import preAnualMeeting23ImageOne from "../../assets/images/pre annual meeting sept 2023/AnualMeeting-23-01.jpg"
import preAnualMeeting23Image2 from "../../assets/images/pre annual meeting sept 2023/AnualMeeting-23-1.jpg"
import preAnualMeeting23Image3 from "../../assets/images/pre annual meeting sept 2023/AnualMeeting-23-2.jpg"
import preAnualMeeting23Image6 from "../../assets/images/pre annual meeting sept 2023/AnualMeeting-23-5.jpg"
import preAnualMeeting23Image10 from "../../assets/images/pre annual meeting sept 2023/AnualMeeting-23-9.jpg"
import preAnualMeeting23Image12 from "../../assets/images/pre annual meeting sept 2023/AnualMeeting-23-11.jpg"
import preAnualMeeting23Image13 from "../../assets/images/pre annual meeting sept 2023/AnualMeeting-23-13.jpg"
import preAnualMeeting23Image14 from "../../assets/images/pre annual meeting sept 2023/AnualMeeting-23-15.jpg"
import preAnualMeeting23Image15 from "../../assets/images/pre annual meeting sept 2023/AnualMeeting-23-16.jpg"
import preAnualMeeting23Image16 from "../../assets/images/pre annual meeting sept 2023/AnualMeeting-23-17.jpg"
import preAnualMeeting23Image17 from "../../assets/images/pre annual meeting sept 2023/AnualMeeting-23-18.jpg"
import preAnualMeeting23Image18 from "../../assets/images/pre annual meeting sept 2023/AnualMeeting-23-21.jpg"
import preAnualMeeting23Image19 from "../../assets/images/pre annual meeting sept 2023/AnualMeeting-23-28.jpg"
import preAnualMeeting23Image20 from "../../assets/images/pre annual meeting sept 2023/AnualMeeting-23-38.jpg"
import preAnualMeeting23Image21 from "../../assets/images/pre annual meeting sept 2023/AnualMeeting-23-39.jpg"
import preAnualMeeting23Image22 from "../../assets/images/pre annual meeting sept 2023/AnualMeeting-23-41.jpg"
import preAnualMeeting23Image23 from "../../assets/images/pre annual meeting sept 2023/AnualMeeting-23-46.jpg"

export const galleryData = {

"2025 Annual Meeting": [
  {
    id: 1,
    title: "Welcome",
    image: preAnualMeeting25Image1,
  },
  {
    id: 2,
    title: "Chief guest lighting lamp",
    image: preAnualMeeting25Image2,
  },
  {
    id: 3,
    title: "President lighting lamp",
    image: preAnualMeeting25Image6,
  },
  {
    id: 4,
    title: "Secretary lighting lamp",
    image:  preAnualMeeting25Image7,
  },
  {
    id: 5,
    title: "Prashant welcoming chief guest",
    image: preAnualMeeting25Image4,
  },
  {
    id: 6,
    title: "Speech by bharath",
    image: preAnualMeeting25Image8,
  },
  {
    id: 7,
    title: "Speech by Govinda",
    image: preAnualMeeting25Image44,
  },
  {
    id: 8,
    title: "Govinda with president",
    image: preAnualMeeting25Image3,
  },
  {
    id: 9,
    title: "Speech by chief guest",
    image: preAnualMeeting25Image9,
  },
  {
    id: 10,
    title: "Speech by president",
    image: preAnualMeeting25Image11,
  },
  {
    id: 11,
    title: "Secretary showing yaf data",
    image: preAnualMeeting25Image10,
  },
  {
    id: 12,
    title: "Youtube live for the first time",
    image: preAnualMeeting25Image13,
  },
  {
    id: 13,
    title: "YAF members with chief guest",
    image: preAnualMeeting25Image12,
  },
],

"2024 Annual Meeting": [
  {
    id: 14,
    title: "YAF members along with the Chief Guest.",
    image: preAnualMeeting24ImageOne,
  },
  {
    id: 15,
    title: "Opening Ceremony ",
    image: preAnualMeeting24Image4,
  },
  {
    id: 16,
    title: "YAF member presenting a bouquet to the Chief Guest.",
    image: preAnualMeeting24Image2,
  },
  {
    id: 17,
    title: "Speech by Chief Guest Sadanand",
    image: preAnualMeeting24Image3,
  },
  {
    id: 18,
    title: "Chief Guest inaugrating our app",
    image: preAnualMeeting24Image5,
  },
  {
    id: 19,
    title: "Chief Guest inaugrating our app",
    image: preAnualMeeting24Image6,
  },
],

"2023 Pre-Annual Meeting": [
  {
    id: 20,
    title: "Welcome YAF members",
    image: preAnualMeeting23ImageOne,
  },
  {
    id: 21,
    title: "All set to start pre annual meeting",
    image: preAnualMeeting23Image14,
  },
  {
    id: 22,
    title: "President with Chief Guest",
    image: preAnualMeeting23Image2,
  },
  {
    id: 23,
    title: "Secretary and President joined Chief Guest Umesh G during the event.",
    image: preAnualMeeting23Image3,
  },
  {
    id: 24,
    title: "Chief Guest Umesh Gudigar inaugurated our Pre-Annual Meeting.",
    image: preAnualMeeting23Image6,
  },
  {
    id: 25,
    title: "Chief Guest Umesh Gudigar inaugurated our Pre-Annual Meeting.",
    image: preAnualMeeting23Image10,
  },
  {
    id: 26,
    title: "Speech by Bharath Chitrika",
    image: preAnualMeeting23Image12,
  },
  {
    id: 27,
    title: "Govinda with president",
    image: preAnualMeeting23Image13,
  },
  {
    id: 28,
    title: "Prashant with Chief Guest",
    image: preAnualMeeting23Image15,
  },
  {
    id: 29,
    title: "Prashant G welcoming the Chief Guest",
    image: preAnualMeeting23Image17,
  },
  {
    id: 30,
    title: "Chiddu giving speech",
    image: preAnualMeeting23Image16,
  },
  {
    id: 31,
    title: "Secretary giving speech",
    image: preAnualMeeting23Image18,
  },
  {
    id: 32,
    title: "Chandan giving speech about development",
    image: preAnualMeeting23Image19,
  },
  {
    id: 33,
    title: "Launch of YAF website",
    image: preAnualMeeting23Image20,
  },
  {
    id: 34,
    title: "Chandan receiving a prize for developing our app.",
    image: preAnualMeeting23Image21,
  },
  {
    id: 35,
    title: "Speech by Govinda G.",
    image: preAnualMeeting23Image22,
  },
  {
    id: 36,
    title: "YAF members along with the Chief Guest.",
    image: preAnualMeeting23Image23,
  },
],

};